import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { Subject } from 'rxjs';
import { DailyReportService } from '../../../../daily-report.service';
import { takeUntil } from 'rxjs/operators';

@Component({
    selector: 'app-control-form-details-wrapper',
    templateUrl: './control-form-details-wrapper.component.html',
    styleUrls: ['./control-form-details-wrapper.component.scss'],
    standalone: false
})
export class ControlFormDetailsWrapperComponent implements OnInit, OnDestroy {
  @Input() data: any;
  disableAddMenu = false;
  private readonly onDestroy: Subject<any> = new Subject<any>();

  constructor(
    private dailyReportService: DailyReportService,
  ) {
  }

  ngOnInit() {
    this.dailyReportService.disableAddMenu
      .pipe(takeUntil(this.onDestroy))
      .subscribe((d) => {
        this.disableAddMenu = d;
      });
  }

  ngOnDestroy() {
    this.onDestroy.next(null);
    this.onDestroy.complete();
  }
}
